module.exports = __webpack_public_path__ + "img/bank.67868bf8.png";